import styled from 'styled-components'

const BriefBox = styled.div`
display: flex;
justify-content: center;
flex-direction: column;
text-align: center;
`

export default BriefBox